<template>
  <ol-map :controls="[]" :projection="projection">
    <ol-view :center="center" :zoom="zoom" :projection="projection" />

    <ol-tile-layer className="dts-background-map">
      <ol-source-osm />
    </ol-tile-layer>

    <Vessels :isVisible="true" :vesselData="[vessel]"></Vessels>
    <Cable :sensorReadings="cable" :isVisible="true" />
  </ol-map>
</template>

<script setup lang="ts">
import { ref, defineProps, onMounted, watch } from 'vue'
import Vessels from './Vessels.vue'
import Cable from './Cable.vue'
import { CableClient, MapCableDataPoint, CableVessel } from '@/server/MakeSenseApp-backend'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'

var projectStore = useProjectStore()

const projection = ref('EPSG:3857')
const zoom = ref(9)
const center = ref([0, 0])

const cable = ref<MapCableDataPoint[]>([])

var props = defineProps({
  vessel: {
    type: CableVessel,
    required: true
  }
})

watch(
  () => props.vessel,
  () => {
    center.value = [props.vessel?.easting ?? 0, props.vessel?.northing ?? 0]
  },
  { immediate: true }
)

onMounted(() => {
  watch(
    () => projectStore.projectId,
    () => {
      var cableClient = requiredInject<CableClient>('CableClient')
      cableClient.cable(projectStore.projectId, null).then((cablePoints) => {
        cable.value = cablePoints
      })
    },
    { immediate: true }
  )
})
</script>

<style>
.ol-map {
  position: relative;
}

.dts-background-map {
  filter: grayscale(100%);
}
</style>
